var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcWechat = function SvgCcWechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1AAD19",
    d: "M15.637 13.856a.505.505 0 0 1-.683-.214l-.034-.076-1.41-3.17a.28.28 0 0 1-.026-.11c0-.147.116-.265.259-.265.058 0 .111.02.154.052l1.665 1.214a.758.758 0 0 0 .689.08L24.08 7.8C22.676 6.107 20.365 5 17.75 5 13.47 5 10 7.96 10 11.612c0 1.992 1.044 3.785 2.678 4.997a.533.533 0 0 1 .19.6l-.35 1.333c-.016.063-.041.128-.041.194 0 .146.115.264.258.264a.288.288 0 0 0 .15-.05l1.696-1.002a.8.8 0 0 1 .412-.122c.079 0 .155.012.227.035a8.968 8.968 0 0 0 2.53.363c4.28 0 7.75-2.96 7.75-6.612 0-1.106-.32-2.148-.883-3.064l-8.923 5.274-.057.034Z"
  })));
};
export default SvgCcWechat;